// extracted by mini-css-extract-plugin
module.exports = {"global-menu-btn":"_2rP4J","globalMenuBtn":"_2rP4J","globalMenuIcon":"_3V4tm"};